/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PuServiceInfo
 */
export interface PuServiceInfo {
    /**
     * 
     * @type {string}
     * @memberof PuServiceInfo
     */
    puServiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuServiceInfo
     */
    puServiceName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PuServiceInfo
     */
    carePrincipals?: Array<string>;
}

export function PuServiceInfoFromJSON(json: any): PuServiceInfo {
    return PuServiceInfoFromJSONTyped(json, false);
}

export function PuServiceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PuServiceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'puServiceId': !exists(json, 'puServiceId') ? undefined : json['puServiceId'],
        'puServiceName': !exists(json, 'puServiceName') ? undefined : json['puServiceName'],
        'carePrincipals': !exists(json, 'carePrincipals') ? undefined : json['carePrincipals'],
    };
}

export function PuServiceInfoToJSON(value?: PuServiceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'puServiceId': value.puServiceId,
        'puServiceName': value.puServiceName,
        'carePrincipals': value.carePrincipals,
    };
}

